import { createRouter, createWebHistory } from "vue-router";

import HomePage from "../pages/HomePage.vue";
import MkToast from "../pages/mk/MkToast.vue";
import MkSandwich from "../pages/mk/MkSandwich.vue";
import MkPizza from "../pages/mk/MkPizza.vue";
import MkSalads from "@/pages/mk/MkSalads.vue";
import MkBeverage from "../pages/mk/MkBeverage.vue";
import MkSides from "../pages/mk/MkSides.vue";
import MkIceCream from "../pages/mk/MkIceCream.vue";
import EnToast from "../pages/en/EnToast.vue";
import EnSandwich from "../pages/en/EnSandwich.vue";
import EnPizza from "../pages/en/EnPizza.vue";
import EnSalads from "@/pages/en/EnSalads.vue";
import EnBeverage from "../pages/en/EnBeverage.vue";
import EnSides from "../pages/en/EnSides.vue";
import EnIceCream from "../pages/en/EnIceCream.vue";
import AlToast from "../pages/al/AlToast.vue";
import AlSandwich from "../pages/al/AlSandwich.vue";
import AlPizza from "../pages/al/AlPizza.vue";
import AlSalads from "@/pages/al/AlSalads.vue";
import AlBeverage from "../pages/al/AlBeverage.vue";
import AlSides from "../pages/al/AlSides.vue";
import AlIceCream from "../pages/al/AlIceCream.vue";
import ContactPage from "@/pages/ContactPage.vue";

import NotFound from "@/pages/NotFound.vue";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/menu/mk/sandwich",
    component: MkSandwich,
  },
  {
    path: "/menu/mk/toast",
    component: MkToast,
  },
  {
    path: "/menu/mk/pizza",
    component: MkPizza,
  },
  {
    path: "/menu/mk/salads",
    component: MkSalads,
  },
  {
    path: "/menu/mk/beverage",
    component: MkBeverage,
  },
  {
    path: "/menu/mk/sides",
    component: MkSides,
  },
  {
    path: "/menu/mk/icecream",
    component: MkIceCream,
  },
  {
    path: "/menu/en/sandwich",
    component: EnSandwich,
  },
  {
    path: "/menu/en/toast",
    component: EnToast,
  },
  {
    path: "/menu/en/pizza",
    component: EnPizza,
  },
  {
    path: "/menu/en/salads",
    component: EnSalads,
  },
  {
    path: "/menu/en/beverage",
    component: EnBeverage,
  },
  {
    path: "/menu/en/sides",
    component: EnSides,
  },
  {
    path: "/menu/en/icecream",
    component: EnIceCream,
  },
  {
    path: "/menu/al/sandwich",
    component: AlSandwich,
  },
  {
    path: "/menu/al/toast",
    component: AlToast,
  },
  {
    path: "/menu/al/pizza",
    component: AlPizza,
  },
  {
    path: "/menu/al/salads",
    component: AlSalads,
  },
  {
    path: "/menu/al/beverage",
    component: AlBeverage,
  },
  {
    path: "/menu/al/sides",
    component: AlSides,
  },
  {
    path: "/menu/al/icecream",
    component: AlIceCream,
  },
  {
    path: "/contact",
    component: ContactPage
  },
  {
    path: "/:notFound(.*)",
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

export default router;
